import i18n from "@/i18n"
import { UserData } from "@/lib/fetch-users"
import { formatDateForChatConversation } from "@/modules/chats/lib/format-chat-date"
import { ChatMessageKind, ChatMessageRole } from "@/modules/chats/types/chat-message"

export const getMessageRole = (messageType: ChatMessageKind, fromSofiaUser: boolean): ChatMessageRole => {
  if (messageType === "participantAdded" || messageType === "participantRemoved") {
    return "system"
  }
  if (fromSofiaUser) {
    return "doctor"
  }
  return "patient"
}

export const getFormattedDisplayName = (sofiaUserInformation: UserData | undefined) => {
  if (!sofiaUserInformation) {
    return ""
  }
  return `${sofiaUserInformation.professionalTitle} ${sofiaUserInformation.firstName} ${sofiaUserInformation.lastName}`
}

export const getMessageContent = (
  messageType: ChatMessageKind,
  messageContent: string,
  messageSentAt: Date,
  senderDisplayName: string,
  language: string,
): string => {
  const { t } = i18n
  if (messageType === "text") {
    return messageContent
  }

  const translationKey = messageType === "participantAdded" ? "chat.conversation.join" : "chat.conversation.left"
  return `${senderDisplayName} ${t(translationKey)} ${formatDateForChatConversation(messageSentAt.toISOString(), language)}`
}
